const heroButtonContainer = <HTMLElement>(
  document.querySelector(".hero__button")
);
if (heroButtonContainer) {
  if (heroButtonContainer.textContent.length > 25) {
    heroButtonContainer.style.padding = "18px 10px";
  }
}

